import { fetchData } from './fetch-data.js';

export class TagService {
  public async getTags() {
    const response = await fetchData(`/api/tags`);

    if (response.status >= 200 || response.status < 400) {
      return await response.json();
    }

    throw new Error(`Es ist ein Fehler beim Laden der Tags aufgetreten.`);
  }
}
